import styled from 'styled-components';

const StyledLayout = styled.div`
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

export { StyledLayout };
